import React, { Component } from 'react';
import { RequestHeaders } from '../../../common/header-logo/request-header.component';
import { HeaderLeftFilter } from '../../../common/header-left-filter/header-left-filter.component';
import { InvoiceTab } from '../invoice-tab/invoice-tab.container';
import att from '../../../../../img/AT&T.png';
import { DataTable } from '../../../common/table/data-table/data-table-component';
import { CalendarScheduler } from './calendar.component';
export class InvoiceCalendar extends Component {
   constructor(props) {
       super(props);
       this.state={
           tabTitle:"",
           dataTable:[],          
       }
       this.wrapperRef = React.createRef();       
       this.handleClickOutside = this.handleClickOutside.bind(this);
       this.onClickTab = this.onClickTab.bind(this);
   }  


   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    }  
    
    handleClickOutside(event) {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({dataTable:[]})   
            this.clearSelectedTab()        
        }    
    }

    clearSelectedTab() {
        const resetActive=document.querySelectorAll('.invoice-status-container')
        for(var i=0;i<resetActive.length;i++) {
            resetActive[i].classList.remove('border-red')
            resetActive[i].classList.remove('border-yellow')
            resetActive[i].classList.remove('border-green')
        }
    }

    onClickTab=(el)=>{   
        const resetActive=document.querySelectorAll('.invoice-status-container')
        var tabValue="" 
        var index="" 
        this.clearSelectedTab()         
        index=el.target.getAttribute("data-index")
       
        if(el.target.attributes.title!==undefined)
        {
           tabValue=el.target.attributes.title.nodeValue 
        } else if(el.target.attributes.title===undefined) {
            tabValue=el.target.parentNode.attributes.title.nodeValue    
        }  
        
        if(tabValue.toLowerCase()==="overdue") { 
            resetActive[index].classList.add("border-red") 
        }
        if(tabValue.toLowerCase()==="expected") { 
            resetActive[index].classList.add("border-yellow") 
        }
        if(tabValue.toLowerCase()==="received") { 
            resetActive[index].classList.add("border-green") 
        } 
        
        this.setState({tabTitle:tabValue})
        this.setState({dataTable:[]})
        if(tabValue.toLowerCase()==="overdue") {            
            this.setState({
                dataTable:[
                    {
                        HeaderItem: [
                            {
                                name: "Vendor"
                            },
                            {
                                name: "Account No."
                            }, {
                                name: "Sub Account No."
                            }, {
                                name: "Interval"
                            }, {
                                name: "Expected Receipt Date"
                            }, {
                                name: "Days Overdue"
                            }
                        ],
                        dataItem: [{
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }
                        ]
                    }
                ]
            })
        }

        if(tabValue.toLowerCase()==="expected") {
            this.setState({
                dataTable:[
                    {
                        HeaderItem: [
                            {
                                name: "Vendor 1"
                            },
                            {
                                name: "Account No."
                            }, {
                                name: "Sub Account No."
                            }, {
                                name: "Interval"
                            }, {
                                name: "Expected Receipt Date"
                            }, {
                                name: "Days Overdue"
                            }
                        ],
                        dataItem: [{
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }
                        ]
                    }
                ]
            })
        }

        if(tabValue.toLowerCase()==="received") {
            this.setState({
                dataTable:[
                    {
                        HeaderItem: [
                            {
                                name: "Vendor 2"
                            },
                            {
                                name: "Account No."
                            }, {
                                name: "Sub Account No."
                            }, {
                                name: "Interval"
                            }, {
                                name: "Expected Receipt Date"
                            }, {
                                name: "Days Overdue"
                            }
                        ],
                        dataItem: [{
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }, {
                            columnItem1: "Globe (PH)",
                            columnItem2: "123456789",
                            columnItem3: "1234567891",
                            columnItem5: "5",
                            columnItem6: "May 15, 2022",
                            columnItem7: "May 15, 2022",
                        }
                        ]
                    }
                ]
            })
        }
    }
    render() {       

        const dropdownItem=[
           {
               ListImg:att,
               ListName:"AT&T"
           },
           {
            ListImg:att,
            ListName:"smart"
           }
        ]; 
        const listStatus=[
            {
                title: "Overdue",
                list: 5,
                bgcolor:'#fff5f7',
                hrcolor:'#d5002f',              
            },
            {
                title: "Expected",
                list: 5,
                bgcolor:'#FFFBEE',
                hrcolor:'#ffc82c',               
            },
            {
                title: "Received",
                list: 5,
                bgcolor:'#F4FBEF',
                hrcolor:'#7ec344',               
            }
        ];

        return(
            <>
             <RequestHeaders headerTitle="Invoices Calendar" />
             <div className="request-table data-table internal-data-table">
                  <HeaderLeftFilter dropdownItem={dropdownItem} />
                  <CalendarScheduler />
                  <div ref={this.wrapperRef}>
                    <div className="invoice-tab-container">
                        <InvoiceTab listStatus={listStatus} onClickTab={this.onClickTab.bind(this)}/>
                    </div> 
                    {this.state.dataTable.length!==0 ? 
                        <div className="invoice-data-table">
                                <h1 className="invoice-tab-title">{this.state.tabTitle}</h1>
                                {this.state.dataTable.map((item, id) =>
                                        <DataTable key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} customClassName="table-container" havePagination={false} />
                                    )}  
                        </div>   
                    : ""}
                  </div> 
                                               
             </div>            
            </>
        )
    }
}